module.exports = __webpack_public_path__ + "img/down-arrow.7a05764c.svg";